/* @flow strict */

import SSRWarning from '/client/src/warnings/SSRWarning';

const available = <T>(name: string, fallback?: T): T => {
  try {
    return window[name];
  } catch (e) {
    if (e instanceof ReferenceError && e.message === 'window is not defined') {
      const { message } = new SSRWarning(`${name} is not available`);

      if (process.env.WARNING_LOG === 'true') {
        console.warn(`SSRWarning: ${message}`);
      }
      return fallback;
    }
    throw e;
  }
};

export default available;
